import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import AuthShell from '../components/layout/AuthShell';
import AlertMessage from '../components/ui/AlertMessage';
import ResultIcon from '../components/ui/ResultIcon';

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const token = searchParams.get('token') || '';

  const [status, setStatus] = useState('checking'); // checking | success | error
  const [message, setMessage] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!token) {
      setStatus('error');
      setMessage('This confirmation link is invalid or has expired.');
      return;
    }

    api.post('/auth/confirm-email-change', { token })
      .then(res => {
        setStatus('success');
        setMessage(res.data.message || 'Your email address has been updated.');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'This confirmation link is invalid or has expired.');
      });
  }, [token]);

  if (status === 'checking') return <LoadingSpinner fullPage label="Confirming the change…" />;

  const ok = status === 'success';

  return (
    <AuthShell
      title="Email change"
      subtitle={ok ? 'Your new address is active' : 'We could not confirm this link'}
    >
      <ResultIcon tone={ok ? 'success' : 'error'} />
      <AlertMessage msg={{ type: ok ? 'success' : 'error', text: message }} />

      {!ok && (
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          Confirmation links expire after 24 hours and can only be used once.
          Start the change again from the Security tab of your dashboard.
        </p>
      )}

      <Link to={user ? '/panel' : '/login'} className="btn-primary w-full py-3">
        {user ? 'Back to dashboard' : 'Go to sign in'}
      </Link>
    </AuthShell>
  );
}
